module.exports = __webpack_public_path__ + "static/media/gift-card-img.349dce7c.png";